<template>
    <div>
        <h3>Vorschau</h3>

        <div v-if="mapping.images && mapping.images.length > 0" class="d-flex flex-row justify-content-center border rounded mb-3">
            <div class="w-75 p-4">
                <img :src="row[mapping.images[0]]" class="w-100">
            </div>
        </div>

        <div v-if="mapping.images && mapping.images.length > 1" class="d-flex flex-row">
            <div v-for="url in mapping.images.slice(1)" class="border rounded mb-3 mr-3 overflow-hidden">
                <img :src="url" style="width: 64px; height: 64px;">
            </div>
        </div>

        <div class="pt-1">
            <table class="table table-borderless table-sm">
                <tr>
                    <td class="text-muted pr-3">Marke</td>
                    <td>{{ brand }}</td>
                </tr>
                <tr v-if="mapping.product_group">
                    <td class="text-muted pr-3">Produktgruppe</td>
                    <td>{{ row[mapping.product_group] }}</td>
                </tr>
                <tr v-if="mapping.ean">
                    <td class="text-muted pr-3">EAN</td>
                    <td>{{ row[mapping.ean] }}</td>
                </tr>
                <tr v-if="mapping.sku">
                    <td class="text-muted pr-3">Artikel-Nr.</td>
                    <td>{{ row[mapping.sku] }}</td>
                </tr>
                <tr v-if="mapping.title">
                    <td class="text-muted pr-3">Titel</td>
                    <td>{{ row[mapping.title] }}</td>
                </tr>
                <tr v-if="mapping.description">
                    <td class="text-muted pr-3">Beschreibung</td>
                    <td>{{ shorten(row[mapping.description]) }}</td>
                </tr>
                <tr v-for="attribute in mapping.attributes">
                    <td class="text-muted pr-3">{{ attribute.attribute.name }}</td>
                    <td>{{ row[attribute.column] }}</td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        mapping: Object,
        attributes: Array,
        brand: String,
        row: Object,
    },

    methods: {
        shorten(text) {
            let shortenTo = 190

            if (text.length < shortenTo) {
                return text
            }

            return text.substring(0, shortenTo) + '...'
        }
    },
}
</script>
